"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConventionalIncomeFields = void 0;
var entities_1 = require("@common/entities");
var COMMON_ADDRESS_FIELDS_1 = require("../COMMON_ADDRESS_FIELDS");
var constants_1 = require("../../constants");
var getConventionalIncomeFields = function (type) {
    switch (type) {
        case entities_1.IncomeTypes.CurrentEmployer:
        case entities_1.IncomeTypes.PreviousEmployer:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Employer Name',
                    name: entities_1.IncomeFields.institutionName.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Text,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(2), true), [
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Supervisor Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 9,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Supervisor Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 10,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Supervisor Fax',
                    name: entities_1.IncomeFields.contactFax.name,
                    required: true,
                    sequence: 11,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Email,
                    enabled: true,
                    label: 'Supervisor Email',
                    name: entities_1.IncomeFields.contactEmail.name,
                    required: true,
                    sequence: 12,
                    type: entities_1.FieldType.Email,
                },
                {
                    customType: entities_1.FieldType.Amount,
                    enabled: true,
                    label: 'Gross Income',
                    name: entities_1.IncomeFields.amount.name,
                    required: true,
                    sequence: 13,
                    type: entities_1.FieldType.Amount,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Job Title',
                    name: entities_1.IncomeFields.positionOrTitle.name,
                    required: true,
                    sequence: 14,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.Date,
                    enabled: true,
                    label: 'Start Date',
                    name: entities_1.IncomeFields.dateStarted.name,
                    required: true,
                    sequence: 15,
                    type: entities_1.FieldType.Date,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 16,
                    type: entities_1.FieldType.File,
                },
            ], false);
        case entities_1.IncomeTypes.SelfEmployer:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Type of Business',
                    name: entities_1.IncomeFields.typeOfBusiness.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Business Tax ID',
                    name: entities_1.IncomeFields.businessTaxId.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Text,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(3), true), [
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Accountant Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 10,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Accountant Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 11,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Date,
                    enabled: true,
                    label: 'Start Date',
                    name: entities_1.IncomeFields.dateStarted.name,
                    required: true,
                    sequence: 12,
                    type: entities_1.FieldType.Date,
                },
                {
                    customType: entities_1.FieldType.Amount,
                    enabled: true,
                    label: 'Gross Income',
                    name: entities_1.IncomeFields.amount.name,
                    required: true,
                    sequence: 13,
                    type: entities_1.FieldType.Amount,
                },
                {
                    customType: entities_1.FieldType.TextArea,
                    enabled: true,
                    label: 'Description',
                    name: entities_1.IncomeFields.description.name,
                    required: true,
                    sequence: 14,
                    type: entities_1.FieldType.TextArea,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 15,
                    type: entities_1.FieldType.File,
                },
            ], false);
        case entities_1.IncomeTypes.OtherIncome:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Income Type',
                    name: entities_1.IncomeFields.institutionName.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Text,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(2), true), [
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Contact Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 9,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 10,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Amount,
                    enabled: true,
                    label: 'Gross Income',
                    name: entities_1.IncomeFields.amount.name,
                    required: true,
                    sequence: 11,
                    type: entities_1.FieldType.Amount,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Job Title',
                    name: entities_1.IncomeFields.positionOrTitle.name,
                    required: true,
                    sequence: 12,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.TextArea,
                    enabled: true,
                    label: 'Description',
                    name: entities_1.IncomeFields.description.name,
                    required: true,
                    sequence: 13,
                    type: entities_1.FieldType.TextArea,
                },
                {
                    customType: entities_1.FieldType.Date,
                    enabled: true,
                    label: 'End Date',
                    name: entities_1.IncomeFields.dateEnded.name,
                    required: true,
                    sequence: 14,
                    type: entities_1.FieldType.Date,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 15,
                    type: entities_1.FieldType.File,
                },
            ], false);
        case entities_1.IncomeTypes.RentVoucher:
            return [
                {
                    customType: entities_1.FieldType.Dropdown,
                    enabled: true,
                    label: 'Frequency',
                    name: entities_1.IncomeFields.frequencyId.name,
                    required: true,
                    sequence: 1,
                    options: Object.keys(constants_1.CONVENTIONAL_INCOME_PAYMENT_INTERVAL).map(function (key) { return ({
                        label: constants_1.CONVENTIONAL_INCOME_PAYMENT_INTERVAL[key],
                        value: key,
                    }); }),
                    type: entities_1.FieldType.Dropdown,
                },
                {
                    customType: entities_1.FieldType.Amount,
                    enabled: true,
                    label: 'Gross Income',
                    name: entities_1.IncomeFields.amount.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Amount,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 3,
                    type: entities_1.FieldType.File,
                },
            ];
        case entities_1.IncomeTypes.BusinessOrRentalIncome:
        case entities_1.IncomeTypes.AidToFamiliesWithDependantChildren:
        case entities_1.IncomeTypes.Annuities:
        case entities_1.IncomeTypes.StudentFinancialAssistanceWorkStudy:
        case entities_1.IncomeTypes.StudentFinancialAssistanceScholarships:
        case entities_1.IncomeTypes.StudentFinancialAssistanceGrants:
        case entities_1.IncomeTypes.StudentFinancialAssistanceLoans:
        case entities_1.IncomeTypes.StudentFinancialAssistanceParentalAssistance:
        case entities_1.IncomeTypes.StudentFinancialAssistanceOther:
        case entities_1.IncomeTypes.ChildSupportOrAlimonyEnforcementAgency:
        case entities_1.IncomeTypes.ChildSupportOrAlimonyCourtOfLaw:
        case entities_1.IncomeTypes.ChildSupportOrAlimonyIndividual:
        case entities_1.IncomeTypes.ChildSupportOrAlimonyOther:
        case entities_1.IncomeTypes.Pensions:
        case entities_1.IncomeTypes.CashContributions:
        case entities_1.IncomeTypes.Commissions:
        case entities_1.IncomeTypes.Dhs:
        case entities_1.IncomeTypes.Disability:
        case entities_1.IncomeTypes.WorkersCompensation:
        case entities_1.IncomeTypes.SupplementalSecurityIncome:
        case entities_1.IncomeTypes.VaBenefits:
        case entities_1.IncomeTypes.TemporaryAssistanceForNeedyFamilies:
        case entities_1.IncomeTypes.RetirementPlanPayments:
        case entities_1.IncomeTypes.SocialSecurity:
        case entities_1.IncomeTypes.GiftPayments:
        case entities_1.IncomeTypes.GeneralAssistance:
        case entities_1.IncomeTypes.VeteransBenefits:
        case entities_1.IncomeTypes.Unemployment:
        case entities_1.IncomeTypes.SeverancePackage:
        case entities_1.IncomeTypes.PublicAssistance:
        case entities_1.IncomeTypes.InterestPayments:
        case entities_1.IncomeTypes.MilitaryPay:
            return __spreadArray(__spreadArray([], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(1), true), [
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Contact Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 8,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 9,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Amount,
                    enabled: true,
                    label: 'Gross Income',
                    name: entities_1.IncomeFields.amount.name,
                    required: true,
                    sequence: 10,
                    type: entities_1.FieldType.Amount,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Job Title',
                    name: entities_1.IncomeFields.positionOrTitle.name,
                    required: true,
                    sequence: 11,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.TextArea,
                    enabled: true,
                    label: 'Description',
                    name: entities_1.IncomeFields.description.name,
                    required: true,
                    sequence: 12,
                    type: entities_1.FieldType.TextArea,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Income',
                    name: entities_1.IncomeFields.documentUpload.name,
                    required: true,
                    sequence: 13,
                    type: entities_1.FieldType.File,
                },
            ], false);
        default:
            return [];
    }
};
exports.getConventionalIncomeFields = getConventionalIncomeFields;
